
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <img className='ui  image' src={require('../../images/icon_q16.gif')} />
    <p>{`Ja, auch wenn sie für den Einschlafenden manchmal störend oder irritierend sind. Die Ursache liegt darin, dass unser Gehirn beim Einschlafen zwischen entspanntem Wachsein und leichtem Schlaf hin und her pendelt. Diese Wechselwirkung betrifft auch unsere Muskeln, die in diesem Zustand eigentlich erschlafft sind, aber sich für kurze Zeit immer wieder mal unwillkürlich anspannen können. Dies führt zu jenen Zuckungen, die viele Menschen schon einmal gespürt haben. `}<M mdxType="M">{`Zwei von fünf Erwachsenen erleben solche Zuckungen regelmässig, nicht vor, sondern während des Einschlafens.`}</M>{` Es handelt sich sozusagen um ein letztes Aufbäumen, bevor die Muskeln ihre Nachtruhe antreten. Zusätzlich können auch Fallgefühle beim Einschlafen auftreten. Auch sie sind unbedenklich.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;